import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import ApiService from '../../../services/ApiService'
import { showAlert } from '../../../utility/SweetAlert'

const InteractorStoreSummarySeller = () => {
  const { t } = useTranslation()
  const [summaryData, setSummaryData] = useState({})
  const { seller } = useSelector((state) => state.seller)
  const summarySeller = useCallback(
    (payload, loadingCallback = () => {}) => {
      const payloadRequest = { ...payload, store_uid: seller.uid }
      loadingCallback(true)
      ApiService.jsonRequest('/store-report/summary-seller', payloadRequest, (response) => {
        loadingCallback(false)
        if (response.status_code === 200) {
          setSummaryData(response.data)
        } else {
          showAlert({
            icon: 'error',
            message: t(`response_message.${response.messages}`),
            timer: 2000,
          })
        }
      })
    },
    [seller.uid, t],
  )

  return { summaryData, summarySeller }
}

export default InteractorStoreSummarySeller
